export function processNavBar(data) {
  let contactus, menuData, logoLink, title, logoImg, contactusLink, logoImg1;

  const head_section = data?.aedheader;
  contactus = head_section?.navigation?.results?.[0].name;
  contactusLink = head_section?.navigation?.results?.[0].hyperlink;
  menuData = head_section?.navigation?.results?.[1].submenu?.results;
  logoLink = head_section?.hyperlink;
  title = head_section?.title;
  logoImg = head_section?.logo?.results?.[0]?.fileUrl;
  logoImg1 = head_section?.logo?.results?.[1]?.fileUrl;

  return {
    contactus,
    menuData,
    logoLink,
    title,
    logoImg,
    contactusLink,
    logoImg1,
  };
}

export function processHeader(data) {
  let title, banner, buttonTitle, buttonHyperLink, pageType, mobileBanner;

  if (data) {
    const keys = Object.keys(data);

    if (keys.length > 0) {
      const key = keys[0];

      pageType = key;
      title =
        data[key]?.banner?.results?.[0]?.maintitle?.content?.[0]?.content?.[0]
          ?.text;
      banner = data[key]?.banner?.results?.[0]?.image?.results?.[0]?.fileUrl;
      buttonTitle = data[key]?.banner?.results?.[0]?.subtitle;
      buttonHyperLink = data[key]?.banner?.results?.[0]?.hyperlink;
      mobileBanner =
        data[key]?.banner?.results?.[0]?.mobileimage?.results?.[0]?.fileUrl;
    }
  }
  return {
    title,
    banner,
    buttonTitle,
    buttonHyperLink,
    pageType,
    mobileBanner,
  };
}

export function processFooter(data) {
  let key;
  if (data) {
    key = Object.keys(data);
  }

  const footerSectionResults = data?.aedfooter;

  const firstColumn = footerSectionResults?.navigation?.results?.[0] ?? null;
  const secondColumn = footerSectionResults?.navigation?.results?.[1] ?? null;
  const thirdColumn = footerSectionResults?.navigation?.results?.[2] ?? null;
  const fourthColumn = footerSectionResults?.navigation?.results?.[3] ?? null;
  const fifthColumn = footerSectionResults?.navigation?.results?.[4] ?? null;

  const termsConditions =
    footerSectionResults?.footerTermsConditions?.results?.[0] ?? null;

  return {
    firstColumn,
    secondColumn,
    thirdColumn,
    fourthColumn,
    fifthColumn,
    termsConditions,
  };
}

export const processHomeData = (data) => {
  const obj = data?.aedhomepage;

  const corouseldata = obj?.scrollingbanner?.results?.[0]?.banners?.results;

  const infodata = obj?.primarycalltoactions?.results?.[0]?.banners?.results;

  const curriculumdata =
    obj?.tertiarycalltoactions?.results?.[0]?.banners?.results;

  const shapingFuture = obj?.primarycontentarticle?.results?.[0];

  const schoolAcademies = obj?.primarystaticbanner?.results?.[0];

  const schoolAcademiesTitle = obj?.primarystaticbanner?.results?.[0]?.title;

  const schoolAcademiesDesc =
    obj?.primarystaticbanner?.results?.[0]?.maintitle?.content?.[0]
      ?.content?.[0]?.text;

  const futureGeneration = obj?.secondarystaticbanner?.results?.[0];

  const futureGenerationTitle = obj?.secondarystaticbanner?.results?.[0]?.title;

  const discoverOurSchool = obj?.secondarycontentarticle?.results?.[0];

  const whyChooseAldar = obj?.secondaryscrollingbanner?.results?.[0];

  const aldarExperienceHub = obj?.tertiarycontentarticle?.results?.[0];

  const aldarExperienceHub1 = obj?.tertiarycontentarticle?.results?.[1];

  const shapingFutureEducation =
    obj?.secondarycalltoactions?.results?.[0]?.banners?.results;

  return {
    corouseldata,
    infodata,
    curriculumdata,
    shapingFuture,
    schoolAcademies,
    futureGeneration,
    discoverOurSchool,
    whyChooseAldar,
    aldarExperienceHub,
    aldarExperienceHub1,
    shapingFutureEducation,
    schoolAcademiesTitle,
    schoolAcademiesDesc,
    futureGenerationTitle,
  };
};

export const processCurriculumData = (data) => {
  let key: any = Object.keys(data);

  const EngcurriculumTitle = data?.[key]?.contentArticle?.results?.[0];
  const learningExperience = data?.[key]?.primarycalltoactions?.results?.[0];

  const contentArticleYourChoiceTitle =
    data?.[key]?.primarycalltoactions?.results?.[0]?.title;

  const infoGridData =
    data?.[key]?.primarycalltoactions?.results?.[0]?.banners?.results;

  const contentArticleYourChoiceDescription =
    data?.[key]?.primarycalltoactions?.results?.[0]?.description;

  const secondaryBannerData = data?.[key]?.secondarybanner?.results?.[0];

  const CurriculumTitle =
    data?.[key]?.secondarycalltoactions?.results?.[0]?.title;
  const CurriculumSubTitle =
    data?.[key]?.secondarycalltoactions?.results?.[0]?.description;

  const InfoMultiGridCurriculum =
    data?.[key]?.secondarycalltoactions?.results?.[0]?.banners.results;

  return {
    infoGridData,
    contentArticleYourChoiceTitle,
    contentArticleYourChoiceDescription,
    secondaryBannerData,
    InfoMultiGridCurriculum,
    CurriculumTitle,
    CurriculumSubTitle,
    EngcurriculumTitle,
    learningExperience,
  };
};

export const processComparisonData = (data) => {
  let key: any = Object.keys(data);

  const contentArticleYourChoiceTitle =
    data?.[key]?.primarycalltoactions?.results?.[0]?.title;

  const infoGridData =
    data?.[key]?.primarycalltoactions?.results?.[0]?.banners?.results;

  const primaryContentArticle =
    data?.[key]?.primarycontentarticle?.results?.[0];
  const primaryContentArticle1 =
    data?.[key]?.primarycontentarticle?.results?.[1]?.title;

  const secondarycontentarticle =
    data?.[key]?.secondarycontentarticle?.results?.[0];
  const secondarycontentarticle1 =
    data?.[key]?.secondarycontentarticle?.results?.[1]?.title;

  const teritiarycontentarticle =
    data?.[key]?.teritiarycontentarticle?.results?.[0];
  const teritiarycontentarticle1 =
    data?.[key]?.teritiarycontentarticle?.results?.[1]?.title;

  const secondaryArticleTitle =
    data?.[key]?.secondarycontentarticle?.results?.[0]?.title;

  const secondaryArticleSummary =
    data?.[key]?.secondarycontentarticle?.results?.[0]?.summary;

  const commonCurriculumGuide =
    data?.[key]?.secondarycontentarticle?.results[0]?.description?.content[0]
      ?.content[0]?.text;

  return {
    contentArticleYourChoiceTitle,
    infoGridData,
    primaryContentArticle,
    secondaryArticleTitle,
    secondaryArticleSummary,
    commonCurriculumGuide,
    primaryContentArticle1,
    secondarycontentarticle,
    secondarycontentarticle1,
    teritiarycontentarticle,
    teritiarycontentarticle1,
  };
};

export const processPageSearchTitle = (data) => {
  const obj = data?.aedpagesearch;

  const ourschools =
    obj?.ourschools !== undefined ? obj?.ourschools : "Our Schools";
  const academies = obj?.academies !== undefined ? obj?.academies : "Academies";
  const searchbartext =
    obj?.searchbartext !== undefined
      ? obj?.searchbartext
      : "Search by community or curriculum";
  return {
    ourschools,
    academies,
    searchbartext,
  };
};

export const processAdvanceSearchTitle = (data) => {
  const obj = data?.aedschoolsearch ?? data?.data?.aedschoolsearch;

  const citySelectionTitle =
    obj?.countrytext?.content[0]?.content[0]?.text ??
    "You want to find a school in";

  const curriculumSelectionTitle =
    obj?.curriculumtext?.content[0]?.content[0]?.text ??
    "You’re interested in:";

  const schoolYearSelectionTitle =
    obj?.gradeyeartext?.content?.[0].content?.[0].text ??
    "For this school year/s:";

  const ratingSelectionTitle =
    obj?.ratingtext?.content?.[0].content?.[0].text ?? "That is";

  const feesSelectionRange =
    obj?.feerangetext?.content?.[0]?.content[0]?.text ?? "For this fee range:";

  const advanceSearchButtonTitle = obj?.searchbuttontext ?? "FIND SCHOOLS";

  return {
    citySelectionTitle,
    curriculumSelectionTitle,
    schoolYearSelectionTitle,
    ratingSelectionTitle,
    feesSelectionRange,
    advanceSearchButtonTitle,
  };
};

export const processAboutData = (data) => {
  const obj = data?.aedaboutuspage;

  const primaryContentArticle = obj?.primarycontentarticle?.results?.[0];
  const primaryscrollingbanner = obj?.primaryscrollingbanner?.results?.[0];
  const primarycalltoactions = obj?.primarycalltoactions?.results?.[0];
  const secondarycalltoactions = obj?.secondarycalltoactions?.results?.[0];
  const teritarycalltoactionsTitle =
    obj?.teritarycalltoactions?.results?.[0]?.title;
  const teritarycalltoactionsDesc =
    obj?.teritarycalltoactions?.results?.[0]?.description;
  const teritarycalltoactions =
    obj?.teritarycalltoactions?.results?.[0]?.banners?.results;
  const secondarycontentarticleTitle =
    obj?.secondarycontentarticle?.results?.[0]?.title;
  const secondarycontentarticleDesc =
    obj?.secondarycontentarticle?.results?.[0]?.description?.content?.[0]
      .content?.[0].text;
  const staticbanner = obj?.staticbanner?.results?.[0];
  const metadata = obj?.metadata?.results?.[0];
  const ourVisions = obj?.secondarycontentarticle?.results;
  const ourJourney = obj?.tertiarycontentarticle?.results?.[0];
  const ourSchool = obj?.teritarycalltoactions?.results?.[0];
  const whatDrives = obj?.quaternarycontentarticle?.results?.[0];
  const celebrateSustainability = obj?.quaternarycontentarticle?.results?.[1];
  const secondarystaticbanner = obj?.secondarystaticbanner?.results?.[0];
  const accreditationBanner =
    obj?.quinarycontentarticle?.results?.[0]?.relatedmedia?.results?.[0]
      ?.fileUrl;
  const accreditationSection = obj?.quinarycontentarticle?.results?.[0];

  return {
    primaryContentArticle,
    primaryscrollingbanner,
    primarycalltoactions,
    secondarycalltoactions,
    teritarycalltoactionsTitle,
    teritarycalltoactionsDesc,
    teritarycalltoactions,
    secondarycontentarticleTitle,
    secondarycontentarticleDesc,
    staticbanner,
    metadata,
    ourVisions,
    ourJourney,
    ourSchool,
    whatDrives,
    celebrateSustainability,
    secondarystaticbanner,
    accreditationBanner,
    accreditationSection,
  };
};

export const processOurHistoryData = (data) => {
  const objPrimary = data?.dataPrimary;
  const objSecondary = data?.dataSecondary;

  const title = objPrimary?.title;
  const description = objPrimary?.description;

  const subtitle1 = objPrimary?.banners?.results?.[0]?.subtitle;
  const title1 = objPrimary?.banners?.results?.[0]?.title;
  const schoolLogo1 =
    objPrimary?.banners?.results?.[0]?.icon?.results?.[0]?.fileUrl;
  const bgImage1 =
    objPrimary?.banners?.results?.[0]?.image?.results?.[0]?.fileUrl;

  const bgImage2 =
    objPrimary?.banners?.results?.[1]?.image?.results?.[0]?.fileUrl;

  const bgImage3 =
    objPrimary?.banners?.results?.[2]?.image?.results?.[0]?.fileUrl;

  const title2 = objPrimary?.banners?.results?.[1]?.title;
  const icon2 = objPrimary?.banners?.results?.[1]?.icon?.results?.[0]?.fileUrl;

  const title3 = objPrimary?.banners?.results?.[2]?.title;
  const icon3 = objPrimary?.banners?.results?.[2]?.icon?.results?.[0]?.fileUrl;

  const title4 = objSecondary?.banners?.results?.[0]?.title;
  const desc4 =
    objSecondary?.banners?.results?.[0]?.maintitle?.content?.[0]?.content?.[0]
      ?.text;
  const icon4 =
    objSecondary?.banners?.results?.[0]?.icon?.results?.[0]?.fileUrl;

  const title5 = objSecondary?.banners?.results?.[1]?.title;
  const desc5 =
    objSecondary?.banners?.results?.[1]?.maintitle?.content?.[0]?.content?.[0]
      ?.text;
  const icon5 =
    objSecondary?.banners?.results?.[1]?.icon?.results?.[0]?.fileUrl;

  return {
    title,
    description,
    subtitle1,
    title1,
    schoolLogo1,
    bgImage1,
    title2,
    icon2,
    title3,
    icon3,
    title4,
    desc4,
    icon4,
    title5,
    desc5,
    icon5,
    bgImage2,
    bgImage3,
  };
};

export const ScrollingPartnershipData = (data) => {
  const schoolData = data?.data?.allAedschoolpage?.results;

  return {
    schoolData,
  };
};

export const processAlumniData = (data) => {
  const obj = data?.aedalumnipage;

  const alumni_metadata =
    obj?.metadata?.results?.length > 0 && obj?.metadata?.results?.[0];
  const alumni_primaryscrollingbanner =
    obj?.primaryscrollingbanner?.results?.length > 0 &&
    obj?.primaryscrollingbanner?.results?.[0];

  const alumni_student_life = obj?.secondaryscrollingbanner?.results?.[0];

  return {
    alumni_metadata,
    alumni_primaryscrollingbanner,
    alumni_student_life,
  };
};

export const processScholarshipData = (data) => {
  const obj = data?.aedscholarshippage;

  const primaryContentArticle = obj?.primarycontentarticle?.results?.[0];
  const scholarshipProgram = obj?.secondarycontentarticle?.results?.[0];

  const secondarycontentArticle =
    obj?.secondarycontentarticle?.results?.[1]?.title;

  const staticbanner = obj?.staticbanner?.results?.[0];

  return {
    primaryContentArticle,
    scholarshipProgram,
    secondarycontentArticle,
    staticbanner,
  };
};

export const processPrivacyPolicyData = (data) => {
  const obj = data?.aedprivacytermspage;

  const title = obj?.contentarticle?.results?.[0]?.title;
  const desc =
    obj?.contentarticle?.results?.[0]?.description?.content?.[0]?.content?.[0]
      ?.text;
  const metadata = obj?.metadata?.results?.[0];
  const summary = obj?.contentarticle?.results?.[0]?.summary;
  const __sysUpdatedAt = obj?.contentarticle?.results?.[0]?.__sysUpdatedAt;

  return { title, desc, metadata, summary, __sysUpdatedAt };
};

export const processTermsOfUseData = (data) => {
  const obj = data?.aedprivacytermspage;

  const title = obj?.contentarticle?.results?.[0]?.title;

  const desc =
    obj?.contentarticle?.results?.[0]?.description?.content?.[0]?.content?.[0]
      ?.text;
  const metadata = obj?.metadata?.results?.[0];
  const summary = obj?.contentarticle?.results?.[0]?.summary;
  const __sysUpdatedAt = obj?.contentarticle?.results?.[0]?.__sysUpdatedAt;

  return { title, desc, metadata, summary, __sysUpdatedAt };
};

export const processCareersData = (data) => {
  const obj = data?.aedcareerpage;

  const primarycontentarticle = obj?.primarycontentarticle?.results?.[0];
  const videoBanner = obj?.secondarystaticbanner?.results?.[0];
  const staticbanner = obj?.staticbanner?.results?.[0];
  const testimonials = obj?.testimonials?.results?.[0];
  const testimonials_banner = obj?.testimonials?.results?.[0].banners?.results;
  const secondarycontentarticle = obj?.secondarycontentarticle?.results?.[0];
  const tertiarystaticbanner = obj?.tertiarystaticbanner?.results?.[0];
  const bannerTitle = obj?.tertiarystaticbanner?.results?.[0]?.title;
  const bannerDescription =
    obj?.tertiarystaticbanner?.results?.[0]?.maintitle?.content?.[0]
      ?.content?.[0]?.text;
  const metadata = obj?.metadata?.results?.[0];

  return {
    staticbanner,
    testimonials,
    testimonials_banner,
    metadata,
    primarycontentarticle,
    videoBanner,
    secondarycontentarticle,
    tertiarystaticbanner,
    bannerTitle,
    bannerDescription,
  };
};

export const processWhyAldarData = (data) => {
  const obj = data?.aedwhyaldareducationpage;

  const primaryContentArticle = obj?.primarycontentarticle?.results?.[0];
  const primaryscrollingbanner = obj?.primaryscrollingbanner?.results?.[0];
  const secondaryscrollingbanner = obj?.secondaryscrollingbanner?.results?.[0];
  const staticbanner = obj?.staticbanner?.results?.[0];
  const metadata = obj?.metadata?.results?.[0];
  const secondarycontentarticle = obj?.secondarycontentarticle?.results?.[0];

  return {
    primaryContentArticle,
    primaryscrollingbanner,
    secondaryscrollingbanner,
    staticbanner,
    metadata,
    secondarycontentarticle,
  };
};

export const processOurParentsData = (data) => {
  const obj = data?.aedourparentspage;

  const primarycontentarticle = obj?.primarycontentarticle?.results?.[0];
  const aldarReward = obj?.secondarycontentarticle?.results?.[0];
  const multivideos = obj?.multivideos?.results?.[0];
  const feedback = obj?.quaternarycontentarticle?.results?.[0];
  const services = obj?.secondaryscrollingbanner?.results?.[0];
  const portal = obj?.tertiarycontentarticle?.results?.[0];

  const primaryscrollingbanner = obj?.primaryscrollingbanner?.results?.[0];
  const testimonials = obj?.testimonials?.results?.[0];
  const testimonials_banner = obj?.testimonials?.results?.[0]?.banners?.results;

  const staticbanner = obj?.staticbanner?.results?.[0];
  const metadata = obj?.metadata?.results?.[0];

  return {
    primaryscrollingbanner,
    testimonials,
    testimonials_banner,
    staticbanner,
    metadata,
    primarycontentarticle,
    aldarReward,
    multivideos,
    feedback,
    services,
    portal,
  };
};

export const processInternationalData = (data) => {
  const obj = data?.aedinternationalconnectionspage;

  const primarycalltoactions = obj?.primarycalltoactions?.results?.[0];
  const primarycalltoactionTitle =
    obj?.primarycalltoactions?.results?.[0]?.title;
  const primarycalltoactionDesc =
    obj?.primarycalltoactions?.results?.[0]?.description;
  const primarycalltoactionBannerList =
    obj?.primarycalltoactions?.results?.[0]?.banners?.results;
  const secondaryBanner = obj?.secondarybanner?.results?.[0];
  const staticbanner = obj?.staticbanner?.results?.[0];
  const metadata = obj?.metadata?.results?.[0];

  return {
    staticbanner,
    metadata,
    primarycalltoactions,
    primarycalltoactionTitle,
    primarycalltoactionDesc,
    primarycalltoactionBannerList,
    secondaryBanner,
  };
};

export const processPageNotFoundData = (data) => {
  const obj = data?.aedpagenotfound;
  const title = obj?.contentarticle?.results?.[0]?.title;
  const relatedmedia =
    obj?.contentarticle?.results?.[0]?.relatedmedia?.results[0];
  const description =
    obj?.contentarticle?.results?.[0]?.description?.content?.[0]?.content?.[0]
      ?.text;
  const exploreMore = obj?.links?.results?.[0]?.name;
  const exploreMoreLink = obj?.links?.results?.[0]?.hyperlink;
  const findRightOne = obj?.links?.results?.[1]?.name;
  const metadata = obj?.metadata?.results?.[0];
  return {
    title,
    relatedmedia,
    description,
    exploreMore,
    exploreMoreLink,
    findRightOne,
    metadata,
  };
};

export const processStudentLifeData = (data) => {
  const obj = data?.aedstudentslifepage;

  const staticbanner = obj?.staticbanner?.results?.[0];
  const metadata = obj?.metadata?.results?.[0];
  const InfoMultiGridSecondaryCallToActions =
    obj?.primarycalltoactions?.results?.[0]?.banners?.results;
  const alumniSlider = obj?.primaryscrollingbanner?.results?.[0];
  const secondaryscrollingbanner = obj?.secondaryscrollingbanner?.results?.[0];
  const primarycontentarticleTitle =
    obj?.primarycontentarticle?.results?.[0]?.title;
  const primarycontentarticleDesc =
    obj?.primarycontentarticle?.results?.[0]?.description?.content?.[0]
      ?.content?.[0]?.text;
  const tertiaryscrollingbanner = obj?.tertiaryscrollingbanner?.results?.[0];

  return {
    primarycontentarticleTitle,
    staticbanner,
    metadata,
    InfoMultiGridSecondaryCallToActions,
    alumniSlider,
    secondaryscrollingbanner,
    primarycontentarticleDesc,
    tertiaryscrollingbanner,
  };
};

export const processContactusData = (data) => {
  const obj = data?.aedcontactuspage;

  const primarycontentarticle = obj?.primarycontentarticle?.results?.[0];
  const watchVideo = obj?.video?.results?.[0]?.videolink?.results?.[0];
  const staticbanner = obj?.staticbanner?.results?.[0];
  const metadata = obj?.metadata?.results?.[0];
  const secondarycontentarticleTitle =
    obj?.secondarycontentarticle?.results?.[0]?.title;
  const secondarycontentarticleDesc =
    obj?.secondarycontentarticle.results?.[0]?.description.content?.[0]
      ?.content?.[0]?.text;
  const faQs = obj?.faqs?.results?.[0];
  const primarycalltoactions = obj?.primarycalltoactions?.results?.[0];
  const primarycalltoaction_maintitle =
    obj?.primarycalltoactions?.results?.[0]?.maintitle?.content?.[0]
      ?.content?.[0]?.text;
  const mapLocator = obj?.mapLocator?.results?.[0];

  return {
    primarycontentarticle,
    watchVideo,
    staticbanner,
    metadata,
    secondarycontentarticleTitle,
    secondarycontentarticleDesc,
    faQs,
    primarycalltoactions,
    primarycalltoaction_maintitle,
    mapLocator,
  };
};

export const processArticleData = (data) => {
  const obj = data?.aedarticlepage;

  const metadata = obj?.metadata?.results?.[0];
  const articles = obj?.articles?.results?.[0];

  return {
    metadata,
    articles,
  };
};

export const processArticleDetailsData = (data) => {
  const obj = data?.aedarticledetailpage;

  const metadata = obj?.metadata?.results?.[0];
  const articles = obj?.articles?.results?.[0];

  const articledetail = obj?.articledetail?.content?.[0]?.content?.[0]?.text;

  return {
    metadata,
    articles,
    articledetail,
  };
};

export const processScrollingPartnershipData = (data) => {
  const obj = data?.allAedschoolpage;
  const obj1 = data?.aedschoolsearch;

  const results = obj?.results;
  const searchresulttext = obj1?.searchresulttext?.content[0]?.content[0]?.text;

  return {
    results,
    searchresulttext,
  };
};

export const purchasesData = (data) => {
  const obj = data?.aedprivacytermspage;

  const title = obj?.contentarticle?.results?.[0]?.title;
  const furthurInfo =
    obj?.contentarticle?.results?.[1]?.description?.content?.[0]?.content?.[0]
      ?.text;
  const desc =
    obj?.contentarticle?.results?.[0]?.description?.content?.[0]?.content?.[0]
      ?.text;
  const metadata = obj?.metadata?.results?.[0];

  return { title, desc, metadata, furthurInfo };
};

export const applicationProcessIntroductionData = (data) => {
  const description = data?.description?.content?.[0]?.content?.[0]?.text;
  const buttonLabel = data?.subtitle;

  return {
    description,
    buttonLabel,
  };
};

export const applicationProcessStudentDetailsData = (data) => {
  const description = data?.description?.content?.[0]?.content?.[0]?.text;

  const studentDetailsLabel = data?.fieldssection?.results?.[0]?.name;
  const studentDetailFields =
    data?.fieldssection?.results?.[0]?.fields?.results;

  const addressLabel = data?.fieldssection?.results?.[1]?.name;
  const addressFields = data?.fieldssection?.results?.[1]?.fields?.results;

  const identificationDetailsLabel = data?.fieldssection?.results?.[2]?.name;
  const identificationDetailFields =
    data?.fieldssection?.results?.[2]?.fields?.results;

  const languageLabel = data?.fieldssection?.results?.[3]?.name;
  const languageFields = data?.fieldssection?.results?.[3]?.fields?.results;

  return {
    description,
    studentDetailsLabel,
    studentDetailFields,
    addressLabel,
    addressFields,
    identificationDetailsLabel,
    identificationDetailFields,
    languageLabel,
    languageFields,
  };
};

export const applicationProcessFamilyDetailsData = (data) => {

  const parentFormLabel = data?.fieldssection?.results;

  const description = data?.description?.content?.[0]?.content?.[0]?.text;

  const identificationDetailFields =
    data?.fieldssection?.results?.[3]?.fields?.results;

  const motherIdentificationDetailFields =
    data?.fieldssection?.results?.[8]?.fields?.results;


  return {
    description,
    identificationDetailFields,
    motherIdentificationDetailFields,
    parentFormLabel
  };
};

export const applicationProcessTestResultsData = (data) => {
  const description = data?.description?.content?.[0]?.content?.[0]?.text;

  const testResultsLabel = data?.fieldssection?.results?.[0]?.name;
  const testResultsFields = data?.fieldssection?.results?.[0]?.fields?.results;

  return {
    description,
    testResultsLabel,
    testResultsFields,
  };
};

export const applicationProcessSecondarySchoolData = (data) => {
  const description = data?.description?.content?.[0]?.content?.[0]?.text;

  const schoolLabel = data?.fieldssection?.results?.[0]?.subtitle;
  const schoolFields = data?.fieldssection?.results?.[0]?.fields?.results;

  return {
    description,
    schoolLabel,
    schoolFields,
  };
};

export const applicationProcessSupportingDocsData = (data) => {

  const formTitle = data?.title;

  const otherDetailsLabel = data?.fieldssection?.results?.[0]?.subtitle;
  const otherDetailsFields = data?.fieldssection?.results?.[0]?.fields?.results;

  const financialDetailsLabel = data?.fieldssection?.results?.[1]?.subtitle;
  const financialDetailsFields =
    data?.fieldssection?.results?.[1]?.fields?.results;

     const darnaDetailsLabel = data?.fieldssection?.results?.[2]?.subtitle;
  const darnaDetailsFields =
    data?.fieldssection?.results?.[2]?.fields?.results;

  return {
    formTitle,
    otherDetailsLabel,
    otherDetailsFields,
    financialDetailsLabel,
    financialDetailsFields,
    darnaDetailsLabel,
    darnaDetailsFields
  };
};

export const getPickList = (data) => {
 
  const countryList = data?.Country;
  const nationalityList = data?.Nationality;
  const religionList = data?.Religion;
  const speakingProficiencyLevelList = data?.SpeakingProficiencyLevel;
  const writingProficiencyLevelList = data?.WritingProficiencyLevel;
  const languageList = data?.Language;
  const GenderList = data?.Gender;
  const Occupation = data?.Occupation;
  const CurrentYearGroup = data?.CurrentYearGroup;
  const CurrentCurriculum = data?.CurrentCurriculum;
  const ResponsibleForPayment = data?.ResponsibleForPayment;
  const InvoicingPreference = data?.InvoicingPreference;
  const SiblingAldarSchools = data?.SiblingAldarSchools;
  const DocumentList = data?.DocumentList;
  const AbuDhabiSchools = data?.AbuDhabiSchools;

  return {
    countryList,
    nationalityList,
    religionList,
    speakingProficiencyLevelList,
    writingProficiencyLevelList,
    languageList,
    GenderList,
    Occupation,
    CurrentYearGroup,
    CurrentCurriculum,
    ResponsibleForPayment,
    InvoicingPreference,
    SiblingAldarSchools,
    DocumentList,
    AbuDhabiSchools
  };
};

export const parentContactUs = (param) => {

  const data = param?.data?.aepcontactuspage;

  const mapLocator = data?.maplocator?.results?.[0];
  const contactusBanner =
    data?.contactus?.results?.[0]?.image?.results?.[0]?.fileUrl;
  const contactusMobileBanner =
    data?.contactus?.results?.[0]?.mobileimage?.results?.[0]?.fileUrl;
  const contactusBannerContent =
    data?.contactus?.results?.[0]?.maintitle?.content?.[0]?.content?.[0]?.text;
  const contactusTitle = data?.contactus?.results?.[0]?.title;
  const contactusFormButton = data?.form?.results?.[0]?.buttons?.results?.[0];
  const contactusFormFields = data?.form?.results?.[0]?.fields?.results;
  const contactusFormDesc =
    data?.form?.results?.[0]?.description?.content?.[0]?.content?.[0]?.text;

  return {
    mapLocator,
    contactusBanner,
    contactusMobileBanner,
    contactusBannerContent,
    contactusTitle,
    contactusFormButton,
    contactusFormFields,
    contactusFormDesc,
  };
};

export const profileSettings = (param) => {
  const data = param?.aepsettingspage;

  const cardTitle = data?.form?.results?.[0]?.title;
  const formTitle =
    data?.form?.results?.[0]?.phase?.results?.[0]?.fieldssection?.results?.[0]
      ?.name;
  const formFields =
    data?.form?.results?.[0]?.phase?.results?.[0]?.fieldssection?.results?.[0]
      ?.fields?.results;

  return {
    cardTitle,
    formTitle,
    formFields,
  };
};

export const profileChangePassword = (param) => {
  const data = param?.aepchangepasswordpage;

  const cardTitle = data?.form?.results?.[0]?.title;
  const formButtonLabel = data?.form?.results?.[0]?.buttons?.results?.[0];

  return {
    cardTitle,
    formButtonLabel,
  };
};

export const createSupportRequest = (param) => {
  const title = param?.description?.content?.[0]?.content?.[0]?.text;
  const buttonLabel = param?.buttons?.results;
  const formDetails = param?.phase?.results?.[0];

  return {
    title,
    buttonLabel,
    formDetails,
  };
};

export const getParentDashboardData = (param) => {
  const data = param?.aepdashboard;
  const multibannerData = data?.multibanner?.results;
  const startApplication = data?.banner?.results?.[0];

  return {
    multibannerData,
    startApplication
  };
};

export const getParentDashboardAppStatusData = (param) => {  
  const appStatusData = param;
  const count = appStatusData?.length || 0
  return {
    appStatusData,
    count
  };
};

export const getApplicationAcademicLabel = (param) => {
  
  const description = param?.description?.content?.[0]?.content?.[0]?.text;
  const academicFields = param?.fieldssection?.results?.[0]?.fields?.results;

  return {
    description,
    academicFields,
  };
};

export const getFileUploadContents = (data) => {
  const description = data?.description?.content?.[0]?.content?.[0]?.text;
  const fileUploadFields = data?.fieldssection?.results?.[0]?.fields?.results;
  const fileUploadTitle = data?.fieldssection?.results?.[0]?.subtitle;

  return {
    description,
    fileUploadFields,
    fileUploadTitle,
  };
};

export const getThankyouContents = (data) => {
  const description = data?.description?.content?.[0]?.content?.[0]?.text;

  return {
    description,
  };
};

export const parentPageNotFoundData = (data) => {
  const obj = data?.aeppagenotfound;

  const title = obj?.contentarticle?.results?.[0]?.title;
  const relatedmedia =
    obj?.contentarticle?.results?.[0]?.relatedmedia?.results[0];
  const description =
    obj?.contentarticle?.results?.[0]?.description?.content?.[0]?.content?.[0]
      ?.text;
  const exploreMore = obj?.links?.results?.[0]?.name;
  const exploreMoreLink = obj?.links?.results?.[0]?.hyperlink;
  const findRightOne = obj?.links?.results?.[1]?.name;
  const metadata = obj?.metadata?.results?.[0];
  return {
    title,
    relatedmedia,
    description,
    exploreMore,
    exploreMoreLink,
    findRightOne,
    metadata,
  };
};

export const profileContents = (response, type) => {
  const key = type === 'student' ? 'studentprofiledetails' : 'parentprofiledetails';
  const data = response?.aepprofilepage?.[key]?.results?.[0];

  return {
    buttonLabel: data?.buttons?.results?.[0],
    formTitle: data?.title,
    formFields: data?.phase?.results?.[0]?.fieldssection?.results,
  };
};
export const parentProfileFields = (param) => {
  const personalDetailsLabel = param?.[0]?.subtitle;
  const personalDetailsFields = param?.[0]?.fields?.results;

  const addressLabel = param?.[1]?.subtitle ? param?.[1]?.subtitle : param?.[1]?.name;
  const addressFields = param?.[1]?.fields?.results;

  const identificationLabel = param?.[2]?.subtitle ? param?.[2]?.subtitle : param?.[2]?.name;
  const identificationFields = param?.[2]?.fields?.results;

  const employmentLabel = param?.[3]?.subtitle;
  const employmentFields = param?.[3]?.fields?.results;

  const addOtherParentFields = param?.[4]?.fields?.results;

  return {
    personalDetailsLabel,
    personalDetailsFields,
    addressLabel,
    addressFields,
    identificationLabel,
    identificationFields,
    employmentLabel,
    employmentFields,
    addOtherParentFields,
  };
};

export const getStudentInfoData = (param) => {
  const data = param?.applicationDetails;

  const studentAddressDetails = data?.addressDetails;
  // const studentLanguageDetails = data?.languagedetails;
  const studentdetailsInfo = data?.studentdetails;

  return {
    studentAddressDetails,
    // studentLanguageDetails,
    studentdetailsInfo,
  };
};

export const getParentInfoData = (param) => {
  const data = param?.applicationDetails;

  const fatherfamilyPayload = data?.familyPayload?.[0];
  const motherfamilyPayload = data?.familyPayload?.[1];

  return {
    fatherfamilyPayload,
    motherfamilyPayload,
  };
};


export const viewAppContents = (data) =>{

   const academicInfo = data?.academicdetails;
   const addressDetails = data?.addressDetails;
   const parentsInformation = data?.parentsInformation;
   const studentdetails = data?.studentdetails;
   const financialDetails = data?.financialDetails;
   const otherDetails = data?.otherDetails;
   const documentsList = data?.documentsList?.filter(
    (item) => item?.SASUrl
  );
   const applicationId = data?.applicationNo;
   const applicationNo = data?.applicationId;
   const maplatitude = data?.Latitude;
   const maplongitude = data?.Longitude;
   const mapLocation = {
    maplatitude,
    maplongitude,
   }
   
   return{
    academicInfo,
    addressDetails,
    parentsInformation,
    studentdetails,
    financialDetails,
    otherDetails,
    documentsList,
    applicationId,
    applicationNo,
    mapLocation
   }
};

export const getStudentWithParentInfo = (data) => {
  const studentInfo = data?.studentDetails;
  const parentInfo = data?.parentDetail;

  return {
    studentInfo,
    parentInfo,
  };
};

export const offerAcceptanceContents = (response) => {
  const data  = response?.aepform;

  const buttonLabel = data?.buttons?.results?.[0] || '';
  const formTitle = data?.title || '';
  const formFields = data?.phase?.results || [];
  const fieldResults = data?.fields?.results || [];
  const formDescription = data?.description?.content?.[0]?.content?.[0]?.text || '';
  const termsConfirm = data?.phase?.results?.[1]?.description?.content?.[0]?.content?.[0]?.text || '';

  return {
    buttonLabel,
    formTitle,
    formFields,
    fields: fieldResults,
    formDescription,
    termsConfirm,
  };
};

export const offerAcceptanceFields = (param) => {
  const [studentDetails, offerAccept] = param;

  const studentDetailsLabel = studentDetails?.name || '';
  const studentDetailsFields = studentDetails?.fieldssection?.results?.[0]?.fields?.results || [];

  const offerAcceptLabel = offerAccept?.name || '';
  const offerAcceptFields = offerAccept?.fieldssection?.results?.[0]?.fields?.results || [];

  return {
    studentDetailsLabel,
    studentDetailsFields,
    offerAcceptLabel,
    offerAcceptFields
  };
};


export const viewApplicationLabel = (param) =>{
  
  const data = param?.aepform;

  const applicationLabel = data?.description?.content?.[0]?.content?.[0]?.text;
  const studentProfile = data?.phase?.results?.[0]?.fieldssection?.results?.[0];
  const academicProfile = data?.phase?.results?.[0]?.fieldssection?.results?.[1];
  const parentInformation = data?.phase?.results?.[0]?.fieldssection?.results?.[2];
  const financialDetails = data?.phase?.results?.[0]?.fieldssection?.results?.[3];
  const otherDetails = data?.phase?.results?.[0]?.fieldssection?.results?.[4];
  const address = data?.phase?.results?.[0]?.fieldssection?.results?.[5];

  return {
    applicationLabel,
    studentProfile,
    academicProfile,
    parentInformation,
    financialDetails,
    otherDetails,
    address
  }
};